import { Button } from "@mantine/core";
import tw from "twin.macro";
export const PrimaryButton = Button;
export const SecondaryButton = tw.button`px-8 py-3 font-bold rounded-md bg-gray-300 text-gray-700 hocus:bg-gray-300 hocus:text-gray-100  focus:outline-none transition-all duration-300`;
export const SectionLine = tw.hr`border-gray-400 border-dashed mx-40 mt-20`;
export const SmallSectionLine = tw.hr`border-gray-400 border-dashed mx-40 mt-10`;
